import { render, staticRenderFns } from "./DatasetIndex.vue?vue&type=template&id=980346a8"
import script from "./DatasetIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports